<mat-slide-toggle color="accent" [formControl]="slideControl">{{header}}</mat-slide-toggle>
